import React from 'react'

export default function Background() {
  return (
  
      <section className="background">
        <div className="background-tint">
        </div> 
    </section>
    
  )
}
